var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb"},[_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_c('span',{class:[item.status ? 'active' : '']},[_vm._v(_vm._s(item.title))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }